
import { Button } from "@/components/ui/button";
import { LoaderCircle, Shield } from "lucide-react";

interface LoanInfoNoticesSvProps {
  isSubmitting: boolean;
}

export const LoanInfoNoticesSv = ({ isSubmitting }: LoanInfoNoticesSvProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-start space-x-2 bg-blue-50 p-3 rounded-md">
        <Shield className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
        <div className="text-xs text-blue-700">
          <p className="font-medium mb-1">Din information är säker</p>
          <p>Vi använder SSL-kryptering för att säkerställa att all din data är skyddad. Vi kommer aldrig att dela din information med obehöriga tredje parter.</p>
        </div>
      </div>
      
      <Button 
        type="submit" 
        className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-md text-lg font-medium"
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <LoaderCircle className="mr-2 h-4 w-4 animate-spin" />
            Skickar ansökan...
          </>
        ) : (
          "Jämför lånerbjudanden"
        )}
      </Button>
      
      <p className="text-xs text-center text-gray-600">
        Att skicka in en ansökan påverkar inte din kreditvärdighet. Det tar bara 2 minuter, och lånerbjudanden börjar dyka upp inom timmar.
      </p>
    </div>
  );
};
